(() => {
  const initHeader = () => {
    const header = document.querySelector('[data-header]');
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';

    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();

    menuToggle?.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu?.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('menu-open', !isOpen);
    });
    mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menuToggle?.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }));
  };

  const initCompare = (scope = document) => {
    scope.querySelectorAll('.compare').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const tabs = section.querySelectorAll('[data-shopify-ride-tab]');
      const stage = section.querySelector('[data-shopify-compare-stage]');
      if (!stage) return;

      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        stage.classList.add('is-switching');
        window.setTimeout(() => {
          const image = stage.querySelector('[data-compare-image]');
          image.src = tab.dataset.image;
          image.alt = tab.dataset.alt || '';
          stage.querySelector('[data-compare-label]').textContent = tab.dataset.label || '';
          stage.querySelector('[data-compare-kicker]').textContent = tab.dataset.kicker || '';
          stage.querySelector('[data-compare-name]').textContent = tab.dataset.name || '';
          stage.querySelector('[data-compare-intro]').textContent = tab.dataset.intro || '';
          ['best', 'range', 'speed', 'motor', 'tires', 'price'].forEach((key) => {
            const target = stage.querySelector(`[data-spec="${key}"]`);
            if (target) target.textContent = tab.dataset[key] || '';
          });
          const link = stage.querySelector('[data-compare-link]');
          link.href = tab.dataset.link || '#';
          link.querySelector('[data-compare-link-label]').textContent = tab.dataset.linkLabel || 'Learn more';
          stage.classList.remove('is-switching');
        }, 220);
      }));
    });
  };

  let revealObserver;
  const initReveals = (scope = document) => {
    const items = scope.querySelectorAll('.reveal:not([data-reveal-ready])');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      items.forEach((item) => { item.dataset.revealReady = 'true'; item.classList.add('is-visible'); });
      return;
    }
    revealObserver ||= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5%' });
    items.forEach((item) => { item.dataset.revealReady = 'true'; revealObserver.observe(item); });
  };

  const init = (scope = document) => { initHeader(); initCompare(scope); initReveals(scope); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
